// Restore Supabase session from localStorage before route middleware runs.
// Without this, auth redirect middleware can fire before async session restore
// completes, causing a spurious redirect to login on SPA page loads (ssr: false).
export default defineNuxtPlugin({
  name: "supabase-init",
  enforce: "pre",
  async setup() {
    const supabase = useSupabaseClient();
    const sessionActive = useState("auth:sessionActive", () => false);
    const route = useRoute();

    const applySession = (hasUser: boolean) => {
      sessionActive.value = hasUser;
    };

    const restoreSession = async () => {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      applySession(Boolean(session?.user));
    };

    // Marketing SSR: still await session restore so auth locks are not contended
    // during hydration (avoids gotrue-js lock warnings in the browser console).
    await restoreSession();
  },
});
